import React, { useState, useEffect, useContext } from 'react';
import FormRoleService from "../../controller/FormRoleController/FormRoleController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import Common from '../../../Common/Common';
function FormListPage() {
    const navigate = useNavigate();
    const [formList, setForms] = useState([]);
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = "accordion-header-light";
    if (theme == "dark") {
        accordTheme = "accordion-header-dark";
    }

    const getParamsFromQueryString = () => {
        const searchParams = new URLSearchParams(window.location.search);
        const params = {};
        for (const [key, value] of searchParams.entries()) {
            params[key] = value;
        }
        return params;
    };

    const params = getParamsFromQueryString();
    const ClientID = params['ClientID'];
    const RoleID = params['RoleID'];
    useEffect(() => {
        async function fetchRoles() {
            try {
                const redirectCallback = () => {
                    navigate('/'); // Redirect to the login page
                };

                const formData = await FormRoleService.GetAllForms(redirectCallback, ClientID, RoleID);
                setForms(formData[0]);
            } catch (error) {
                console.error('Error fetching Roles:', error);
            }
        }
        fetchRoles();
    }, []);


    return (
        <div>
            <Common />
            <div className="main-content-header">
                <h1>Assign Form to Role</h1>
            </div>
            <div className="row">
                <div className="col-xl-12">
                    <div className="card mb-30">
                        <div className="card-body">
                            <div className="row mb-3">



                                <Link className='btn btn-primary' to={`/CreateAssignForm?ClientID=${ClientID}&RoleID=${RoleID}`}>
                                    <i className='bi bi-plus-lg'></i>
                                    Assign new Form
                                </Link>

                                <Link className='btn btn-secondary' to={`/AdministrationSetting`} style={{"marginLeft":"5px"}}>
                                    <i className='bi bi-plus-lg'></i>
                                    Back
                                </Link>

                            </div>
                            <table className="table datatable table-bordered">
                                <thead>
                                    <tr>
                                        <th>Form ID</th>
                                        <th>Form Name</th>
                                        <th>Module</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formList.map(form => (
                                        <tr>
                                            <td>{form.ID}</td>
                                            <td>{form.FormName}</td>
                                            <td>{form.vc_ModuleName}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default FormListPage;